import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, MbsSize, ModalComponent, ModalFooterDirective, ModalService, RadioComponent } from 'mbs-ui-kit';
import { EditPresetModalComponent } from 'mbs-ui-shared@components/admin-permission-presets/edit-preset-modal/edit-preset-modal.component';
import { AdminPermissionPresetsFacade } from 'mbs-ui-shared@facades/admin-permission-presets.facade';
import { AdminPermissionPreset } from 'mbs-ui-shared@models/AdminPermissionPreset';
import { catchError, from, of, take } from 'rxjs';

@Component({
  selector: 'mbs-apply-preset-modal',
  templateUrl: './apply-preset-modal.component.html',
  styleUrls: ['./apply-preset-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, I18NextPipe, ModalComponent, ModalFooterDirective, RadioComponent, ReactiveFormsModule]
})
export class ApplyPresetModalComponent {
  private presetsFacade = inject(AdminPermissionPresetsFacade);
  private modal = inject(ModalService);

  public readonly MbsSize = MbsSize;
  public readonly presets = this.presetsFacade.presets;
  public readonly selectedPresetId = new FormControl<string>(null);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public handleEdit(preset: AdminPermissionPreset): void {
    from(this.modal.openCustom(EditPresetModalComponent, { data: { preset } }))
      .pipe(
        catchError(() => of(null)),
        take(1)
      )
      .subscribe();
  }

  public apply(): void {
    this.baseModal.save(this.presets().find(({ id }) => id === this.selectedPresetId.value));
  }
}
